import React from 'react';

const StatusPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-white">
      <section className="pt-24 pb-12 bg-gradient-to-br from-indigo-50 via-white to-blue-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-4xl font-bold text-gray-900 mb-4">System Status</h1>
          <p className="text-gray-600 max-w-3xl">All systems operational. Uptime reports will appear here.</p>
        </div>
      </section>
    </div>
  );
};

export default StatusPage;
